<div class="autorizacionESF tab-pane fade show active">
    <div class="cabeceraTabla row">
        <div class="col-12 col-md-3 col-sm-5">
            <label translate="" for="textESF">cli.adhesionList.labelBs</label>
            <input type="text" id="textESF" name="buscadorESF" class="col-12"
                   [(ngModel)]="filter.invoicingService" placeholder="{{'cli.adhesionList.placeholderBs' | translate}}" (keyup)="onKeyUp()">
        </div>
        <div class="col-12 col-md-3 col-sm-5">
            <label for="textDIRe" translate>cli.adhesionList.labelDire</label>
            <input type="text" id="textDIRe" name="buscadorDIRe" class="col-12"
                   [(ngModel)]="filter.dire" placeholder="{{'cli.adhesionList.placeholderdire' | translate}}" (keyup)="onKeyUp()">
        </div>
        <div class="col-12 col-md-2 col-sm-2">
            <label for="buscadorEstado" translate>cli.adhesionList.labelStatus</label>
            <select id="buscadorEstado" name="buscadorEstado" class="selectSingularPF custom-select col"
                    [(ngModel)]="filter.status" (change)="onKeyUp()">
                <option selected></option>
                <option value="P" translate>cli.adhesionList.labelStatusP</option>
                <option value="A" translate>cli.adhesionList.labelStatusA</option>
                <option value="C" translate>cli.adhesionList.labelStatusC</option>
                <option value="E" translate>cli.adhesionList.labelStatusCD</option>
            </select>
        </div>
        <div class="col btNuevaPlataforma align-bottom">
            <button type="button" class=" btn btn-primary pull-right" (click)="newAdhesionStep1 = true" translate><i class="fa fa-plus"></i> cli.adhesionList.buttonCreateAdhesion</button>
        </div>
    </div>
    <table class="table table-hover table-striped">
        <thead>
        <tr>
            <th scope="col">
                <span class="d-none d-lg-block" translate>cli.adhesionList.headerBsNameFull</span><span class="d-block d-lg-none" translate>cli.adhesionList.headerBsName</span>
            </th>
            <th scope="col" > <span class="d-block d-md-none" translate>cli.adhesionList.headerDire</span><span class="d-none d-md-block" translate>cli.adhesionList.headerDireFull</span></th>
            <th scope="col" class="text-center d-none d-lg-table-cell"> <span translate>cli.adhesionList.headerDate</span></th>
            <th scope="col" class="text-center d-none d-sm-table-cell" ><span translate>cli.adhesionList.headerStatus</span></th>
            <th scope="col" class="text-right d-none d-lg-table-cell"><span translate>cli.adhesionList.headerActions</span></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="clientAdhesionList.items.length === 0 && (!newAdhesionStep1 && !newAdhesionStep2)" class="noResultFound">
            <td colspan="5"><span translate>cli.adhesionList.noResultFound</span></td>
        </tr>

        <tr *ngIf="newAdhesionStep1" class="nuevaAutorizacion multiple step1">
            <td colspan="5">
                <div class="timeline row">
                    <span class="col active d-none d-lg-block" translate>cli.adhesionList.timeline.esf</span>
                    <span class="col active d-block d-lg-none">ESF</span>
                    <span class="col separador d-none d-sm-table-cell"></span>
                    <i class="fa ico fa-angle-right "></i>
                    <span class="col d-none d-lg-block" translate>cli.adhesionList.timeline.dire</span>
                    <span class="col d-block d-lg-none">DIRe</span>
                    <span class="col separador d-none d-sm-table-cell"><em></em></span>
                    <i class="fa ico fa-angle-right "></i>
                    <span class="col" translate>cli.adhesionList.timeline.acepted</span>
                </div>
                <div class="row">
                    <div class="col-12 intro">
                        <p translate>cli.adhesionList.selecEsfText</p>
                    </div>
                    <div class="col-12 col-sm-6">
                        <label translate>cli.adhesionList.labelESFAuthorized</label>
                        <input id="autocompleteBs" type="text" name="empresaESF" class=" campoBusqueda col-12" [(ngModel)]="modelBs" [ngbTypeahead]="searchBs" [class.is-invalid]="searchFailed" placeholder="Selecionar ESF a autorizar" (selectItem)="onSelectBsItem($event)" [resultFormatter]="formatter"/>
                    </div>
                </div>
                <div class="col-12 botoneraAccion">
                    <div class="pull-right">
                        <button title="{{'cli.adhesionList.buttonCancel' | translate}}" class="" (click)="clearNewAdhesion()" translate><i class="fa fa-times"></i> <span translate>cli.adhesionList.buttonCancel</span></button>
                        <button title="{{'cli.adhesionList.buttonNext' | translate}}" class="" [disabled]="!clientAdhesion.invoicingServiceIdentifier" (click)="showStep2()" translate><span translate>cli.adhesionList.buttonNext</span> <i class="fa fa-angle-right"></i></button>
                    </div>
                </div>
            </td>
        </tr>

        <tr *ngIf="newAdhesionStep2" class="nuevaAutorizacion multiple step2">
            <td colspan="5">
                <div class="timeline row">
                    <span class="col active clickable d-none d-lg-block"  (click)="showStep1()" translate>cli.adhesionList.timeline.esf</span>
                    <span class="col active clickable d-block d-lg-none" (click)="showStep1()">ESF</span>
                    <span class="col active separador d-none d-sm-table-cell"></span>
                    <i class="fa ico active fa-angle-right "></i>
                    <span class="col active d-none d-lg-block" translate>cli.adhesionList.timeline.dire</span>
                    <span class="col active d-block d-lg-none">DIRe</span>
                    <span class="col separador d-none d-sm-table-cell"><em></em></span>
                    <i class="fa ico fa-angle-right "></i>
                    <span class="col" translate>cli.adhesionList.timeline.acepted</span>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 col-lg-5">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <label translate>cli.adhesionList.labelDire</label>
                                        <input type="text" id="autocompleteDire" name="unidadDIRe" class="col-12 campoBusqueda" [(ngModel)]="clientFilter.searchedText" placeholder="Buscar Unidades DIRe" (keyup)="onKeyUpAdhesion()">
                                        <span translate class="searching" *ngIf="searchingDire && clientFilter.searchedText.length > 2">cli.adhesionList.labelSearchingDire</span>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <label translate>cli.adhesionList.labelDireFather</label>
                                        <input type="text" id="autocompleteDireParent" name="unidadDIReParent" class="col-12 campoBusqueda" [(ngModel)]="clientFilter.searchedTextParent" placeholder="Buscar Unidades DIRe" (keyup)="onKeyUpAdhesion()">
                                        <span translate class="searching" *ngIf="searchingDire && clientFilter.searchedTextParent.length > 2">cli.adhesionList.labelSearchingDire</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg">
                        <div class="col-12 adhesionListNewAdd">
                            <div class="pseudoTablethead">
                                <div class="row">
                                    <div class="campoCheck">
                                        <label _ngcontent-c16="" class="form-check-label pseudocheck">
                                            <input _ngcontent-c16="" class="form-check-input" type="checkbox" [(ngModel)]="checkboxDireList" (change)="checkAll($event, 'Left')">
                                            <span _ngcontent-c16=""></span>
                                        </label>
                                    </div>
                                    <div class="col">
                                        <span translate>
                                            cli.adhesionList.labelDireSeleccionables
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="pseudoTablebody">
                                <div *ngFor="let dire of direList.items" class="row">
                                    <div class="campoCheck">
                                        <label _ngcontent-c16="" class="form-check-label pseudocheck">
                                            <input _ngcontent-c16="" class="form-check-input" type="checkbox" [(ngModel)]="dire.selected" (change)="checkOrUncheck($event, dire, 'Left')">
                                            <span _ngcontent-c16=""></span>
                                        </label>
                                    </div>
                                    <div class="col">{{ dire.name }} - {{ dire.code }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-1 btAnadir">
                        <button title="{{'cli.adhesionList.buttonAdd' | translate}}" (click)="addTodireList()">
                            <i class="fa fa-angle-double-right d-none d-lg-block"></i>
                            <i class="fa fa-angle-double-down d-block d-lg-none"></i>
                        </button>
                        <button title="{{'cli.adhesionList.buttonRemove' | translate}}" (click)="deleteTodireList()">
                            <i class="fa fa-angle-double-left d-none d-lg-block"></i>
                            <i class="fa fa-angle-double-up d-block d-lg-none"></i>
                        </button>
                    </div>
                    <div class="col-12 col-lg">
                        <div class="col-12 adhesionListNewAdd">
                            <div class="pseudoTablethead">
                                <div class="row">
                                    <div class="campoCheck">
                                        <label _ngcontent-c16="" class="form-check-label pseudocheck">
                                            <input _ngcontent-c16="" class="form-check-input" type="checkbox" [(ngModel)]="checkboxDireListAdded" (change)="checkAll($event, 'Right')">
                                            <span _ngcontent-c16=""></span>
                                        </label>
                                    </div>
                                    <div class="col">
                                        <span translate>
                                            cli.adhesionList.labelDireAuthorizeds
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="pseudoTablebody">
                                <div *ngFor="let direAdded of direListAdded" class="row">
                                    <div class="campoCheck">
                                        <label _ngcontent-c16="" class="form-check-label pseudocheck">
                                            <input _ngcontent-c16="" class="form-check-input" type="checkbox" [(ngModel)]="direAdded.selected" (change)="checkOrUncheck($event, direAdded, 'Right')">
                                            <span _ngcontent-c16=""></span>
                                        </label>
                                    </div>
                                    <div class="col">{{ direAdded.name }} - {{ direAdded.code }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 botoneraAccion">
                    <div class="pull-right">
                        <button title="{{'cli.adhesionList.buttonPre' | translate}}" class="" (click)="showStep1()" translate><i class="fa fa-angle-left"></i> <span translate>cli.adhesionList.buttonPre</span></button>
                        <button title="{{'cli.adhesionList.buttonCancel' | translate}}" class="" (click)="clearNewAdhesion()" translate><i class="fa fa-times"></i> <span translate>cli.adhesionList.buttonCancel</span></button>
                        <button title="{{'cli.adhesionList.buttonNext' | translate}}" class="" (click)="showStep3()" [disabled]="direListAdded.length == 0" translate><span translate>cli.adhesionList.buttonNext</span> <i class="fa fa-angle-right"></i></button>
                    </div>
                </div>
            </td>
        </tr>

        <tr *ngIf="newAdhesionStep3" class="nuevaAutorizacion multiple step3">
            <td colspan="5">
                <div class="timeline row">
                    <span class="col active clickable d-none d-lg-block" (click)="showStep1()" translate>cli.adhesionList.timeline.esf</span>
                    <span class="col active clickable d-block d-lg-none"(click)="showStep1()" >ESF</span>
                    <span class="col active separador d-none d-sm-table-cell"></span>
                    <i class="fa ico active fa-angle-right "></i>
                    <span class="col active clickable d-none d-lg-block" (click)="showStep2()" translate>cli.adhesionList.timeline.dire</span>
                    <span class="col active clickable d-block d-lg-none"(click)="showStep2()" >DIRe</span>
                    <span class="col active separador d-none d-sm-table-cell"><em></em></span>
                    <i class="fa ico active fa-angle-right "></i>
                    <span class="col active" translate>cli.adhesionList.timeline.acepted</span>
                </div>
                <div class="row">
                    <div class="col-12 intro">
                        <p [innerHTML]="'cli.adhesionList.newResumen' | translate:{ ESF:modelBs }"></p>
                    </div>
                    <div class="col-12">
                        <div class="col-12 adhesionListNewAdd">
                            <div class="pseudoTablethead">
                                <div class="row">
                                    <div class="col">
                                        <span translate>
                                            cli.adhesionList.labelDire
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="pseudoTablebody">
                                <div *ngFor="let direAdded of direListAdded" class="row">
                                        <div class="col">{{ direAdded.name }} - {{ direAdded.code }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="notaPie col-7 ml-auto">
                    <div *ngIf="errors && errors.length > 0">
                        <span *ngFor="let error of errors">
                             {{ error.dire }}
                        </span>
                    </div>
                </div>

                <div class="col-12 botoneraAccion">
                    <div class="pull-right">
                        <button title="{{'cli.adhesionList.buttonPre' | translate}}" class="" (click)="showStep2()" translate><i class="fa fa-angle-left"></i> <span translate>cli.adhesionList.buttonPre</span></button>
                        <button title="{{'cli.adhesionList.buttonAcept' | translate}}" class="" (click)="openConfirmAuth()" translate><i class="fa fa-check"></i> <span translate>cli.adhesionList.buttonAcept</span></button>
                        <button title="{{'cli.adhesionList.buttonCancel' | translate}}" class="" (click)="clearNewAdhesion()" translate><i class="fa fa-times"></i> <span translate>cli.adhesionList.buttonCancel</span></button>
                    </div>
                </div>
            </td>
        </tr>
        <tr *ngFor="let clientAdhesion of clientAdhesionList.items | paginate: { itemsPerPage: itemsPerPage, currentPage: p }; let i=index">
            <td>{{ clientAdhesion.invoicingService.identifier }}
                <span class="truncateTD">{{ clientAdhesion.invoicingService.tradeName }}</span></td>
            <td translate>{{ clientAdhesion.dire.code }}<span class="truncateTD">{{ clientAdhesion.dire.name }}</span></td>
            <td class="text-center d-none d-lg-table-cell">{{ clientAdhesion.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td class="text-center d-none d-sm-table-cell" translate>{{ adhesionStatusMapping[clientAdhesion.status] }}</td>
            <td class="text-right d-none d-lg-table-cell">
                <button *ngIf="clientAdhesion.status == 'P'" title="{{'cli.adhesionList.buttonNoApply' | translate}}" translate (click)="onCancelClientAdhesionClicked(clientAdhesion)"><i class="fa fa-ban"> <span translate>cli.adhesionList.buttonNoApply</span></i></button>
            </td>
        </tr>
        </tbody>
    </table>

    <div *ngIf="clientAdhesionList.items.length > 0" class="paginador">
        <pagination-controls (pageChange)="p = $event" autoHide="true"
                             previousLabel="{{'inv.list.previous' | translate}}"
                             nextLabel="{{'inv.list.next' | translate}}" class="pull-right">
        </pagination-controls>

        <div class="controlPaginador pull-left">
            <label class="d-none d-sm-inline-block" translate>cli.list.clientAdhesionPage</label>
            <select [(ngModel)]="itemsPerPage" class="custom-select">
                <option value="5" selected>5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="1000">1000</option>
            </select>
        </div>
    </div>
</div>

<!-- MODAL -->
<ng-template #updateClientAdhesion let-c="close">
    <div class="modal-header">
        <h5 class="modal-title" translate>cli.adhesionList.modal.title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p translate>cli.adhesionList.modal.cancelAddesion</p>
    </div>
    <div class="modal-footer">
        <div class="botonera">
            <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>cli.adhesionList.modal.btnCancel</button>
            <button type="button" class="btn btn-primary" (click)="c('update')" translate>cli.adhesionList.modal.btnOk</button>
        </div>
    </div>
</ng-template>

<!-- MODAL confirm authorization -->
<ng-template #confirmAuthorization let-c="close">
    <div class="modal-header">
        <h5 class="modal-title" translate>inv.receiver.modal.authorization.title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" [innerHTML]="'inv.receiver.modal.authorization.body' | translate:{ empresa: modelBs}">
    </div>
    <div class="modal-footer">
        <div class="botonera">
            <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>inv.receiver.modal.cancel</button>
            <button type="button" class="btn btn-primary" (click)="c('createAuth')" translate>inv.receiver.modal.accept</button>
        </div>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-adhesion-list/cli-adhesion-list.component.html